import React, { FC } from 'react'

import { map } from 'lodash'
import { Button } from 'common/styles/layouts'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { Text } from '@interco/inter-ui/components/Text'
import { uuid } from '@interco/inter-ui'

import {
  EntityMenuBottomSheetAllContentContainer,
  EntityMenuBottomSheetContainer,
  EntityMenuBottomSheetContentContainer,
} from '../styles'
import { TEntityMenuBottomSheetProps } from '../types'

export const EntityMenuBottomSheet: FC<TEntityMenuBottomSheetProps> = ({
  bottomsheetClickHandler,
  infoBottomsheet,
}) => (
  <BottomSheet onClose={bottomsheetClickHandler}>
    <EntityMenuBottomSheetContainer>
      <Text variant="headline-h3" color="typography" colorWeight={500} as="p" semiBold>
        {infoBottomsheet.title}
      </Text>
      <EntityMenuBottomSheetAllContentContainer>
        {map(infoBottomsheet.content, (content) => (
          <EntityMenuBottomSheetContentContainer key={uuid()}>
            {content?.title && (
              <Text variant="body-3" color="typography" colorWeight={500} as="p" bold>
                {content.title}
              </Text>
            )}
            <Text variant="caption-1" color="typography" colorWeight={500} fontWeight={400} as="p">
              {content.details}
            </Text>
            {content?.numberedList &&
              map(content.numberedList, (item, index) => (
                <Text
                  variant="caption-1"
                  color="typography"
                  colorWeight={500}
                  fontWeight={400}
                  as="p"
                >
                  {`${index + 1}. ${item}`}
                </Text>
              ))}
          </EntityMenuBottomSheetContentContainer>
        ))}
      </EntityMenuBottomSheetAllContentContainer>
      <Button onClick={bottomsheetClickHandler} fullWidth>
        {infoBottomsheet.confirmButton}
      </Button>
    </EntityMenuBottomSheetContainer>
  </BottomSheet>
)
